import 'core-js/stable';
import 'focus-visible';
import 'jquery-lazy';
import 'slick-carousel';
import '@electro-creative-workshop/electro-privacy';
import './components/to-top.js';

import Alerts from './components/alerts';
import Navigation from './components/navigation';
import SocialBar from './components/social-bar';
import Microsites from './pages/microsites';
import WorldCup2018 from './pages/world-cup-2018';
import GuysTime from './pages/guys-time';
import SummertimeFamilyBBQ from './pages/summertime-family-bbq';
import TasteOfTheGame from './pages/taste-of-the-game';
import Thanksgrilling from './pages/thanksgrilling';
import Tailgating from './pages/tailgating2021';
import PreserveThePit from './pages/preserve-the-pit';
import RecipesPage from './pages/recipes-page';
import SignatureFlavors from './pages/signature-flavors';
import SingleRecipePage from './pages/single-recipe-page';

new Alerts();
new Navigation();
new SocialBar();

if (document.location.pathname.indexOf('/futbol/') == 0) {
  new Microsites();
  new WorldCup2018();
} else if (document.location.pathname.indexOf('/guys-time/') == 0) {
  new Microsites();
  new GuysTime();
} else if (document.location.pathname.indexOf('/summertime-family-bbq/') == 0) {
  new Microsites();
  new SummertimeFamilyBBQ();
} else if (document.location.pathname.indexOf('/recipes/') == 0) {
  new RecipesPage();
} else if (document.location.pathname.indexOf('/recipe/') == 0) {
  new SingleRecipePage();
} else if (document.location.pathname.indexOf('/taste-of-the-game/') == 0) {
  new TasteOfTheGame();
} else if (document.location.pathname.indexOf('/thanksgiving-recipes/') == 0) {
  new Thanksgrilling();
} else if (document.location.pathname.indexOf('/tailgating/') == 0) {
  new Tailgating();
} else if (document.location.pathname.indexOf('/preserve-the-pit/') == 0) {
  new PreserveThePit();
} else if (document.location.pathname.indexOf('/flavors/') == 0) {
  new SignatureFlavors();
}
